import { t } from 'i18next';
import { RedirectPage } from '../../../components/redirect-page';
import { platformLabel, useEnv } from '../../../context/env-context';
import { withPageProviders } from '../../../context/page-context';

export const CustomerGroupsRedirectPage = withPageProviders(CustomerGroupsRedirectContent);

function CustomerGroupsRedirectContent() {
  const platform = platformLabel(useEnv().connected_platform);

  return (
    <RedirectPage
      path="/customers/groups"
      title={t('features:customer_group.pages.redirect.title', { platform })}
      subtitle={t('features:customer_group.pages.redirect.description', { platform })}
      action={t('features:customer_group.pages.redirect.action')}
      imageType="customerGroup"
    />
  );
}
